// This component is generated by svgr. DO NOT EDIT.
import { SVGProps } from 'react'
type Props = {
  size?: 'sm' | 'md' | 'lg' | (string & {}),
} & Omit<SVGProps<SVGSVGElement>, 'width' | 'height'>
const SvgFollowup = ({ size = 'md', ...props }: Props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={
      size === 'sm'
        ? '8px'
        : size === 'md'
        ? '16px'
        : size === 'lg'
        ? '24px'
        : size
    }
    height={
      size === 'sm'
        ? '8px'
        : size === 'md'
        ? '16px'
        : size === 'lg'
        ? '24px'
        : size
    }
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      fill={props.color ?? 'currentColor'}
      fillRule="evenodd"
      d="M1 1a1 1 0 0 1 1 1v11h13a1 1 0 1 1 0 2H1a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1"
      clipRule="evenodd"
    />
    <path
      fill={props.color ?? 'currentColor'}
      fillRule="evenodd"
      d="M13.555 4.168a1 1 0 0 1 .277 1.387l-2 3a1 1 0 0 1-1.074.415L7.44 8.141l-1.609 2.414a1 1 0 0 1-1.664-1.11l2-3a1 1 0 0 1 1.075-.415l3.316.829 1.61-2.414a1 1 0 0 1 1.386-.277"
      clipRule="evenodd"
    />
  </svg>
)
export default SvgFollowup
